import { contactLegalData } from "../../data/legalRequisites";
import paymentCardsImg from "../../icons/payment-cards.png";
import paymentSecurityImg from "../../icons/payment-security.png";

const Payment = () => {
  return (
    <main className="text-main pad payment-page">
      <div className="container">
        <h3>Оплата</h3>

        <section className="payment-cards-section" aria-label="Принимаемые платёжные системы">
          <p>
            К оплате принимаются карты <strong>VISA</strong>, <strong>MasterCard</strong>, <strong>МИР</strong>.
          </p>
          <p>
            Для оплаты банковской картой нажмите кнопку «Оплата заказа банковской картой».
          </p>
          <p>
            Оплата происходит через <strong>ВТБ (ПАО)</strong>.
          </p>
          <div className="payment-systems-logos">
            <img
              src={paymentCardsImg}
              alt="VISA, MasterCard, МИР"
              className="payment-systems-img"
            />
          </div>
        </section>

        <section className="payment-security" aria-label="Безопасность платежей">
          <p>
            Сервис осуществляет приём платежей в соответствии с правилами платёжных систем МИР, Visa International, MasterCard Europe Sprl. Соблюдаются конфиденциальность и безопасность при использовании современных методов верификации, шифрования и передачи данных по защищённым каналам связи.
          </p>
          <p>
            На сайте используется 256-битное шифрование. Подключение к платёжному шлюзу и передача данных осуществляются по защищённому соединению по протоколу SSL. Введённые данные не передаются третьим лицам, за исключением случаев, предусмотренных законодательством Российской Федерации.
          </p>
          <p>
            Обработка платежей соответствует требованиям платёжных систем МИР, Visa Int., MasterCard Europe Sprl.
          </p>
          <div className="payment-security-logos">
            <img
              src={paymentSecurityImg}
              alt="Verified by VISA, MasterCard SecureCode, МИР Accept"
              className="payment-security-img"
            />
          </div>
        </section>

        <h6>Способы оплаты</h6>
        <ul>
          <li>Банковской картой (VISA, MasterCard, МИР)</li>
          <li>Система быстрых платежей</li>
          <li>Оплата с личного счёта на сайте</li>
        </ul>

        <section className="payment-requisites" aria-label="Реквизиты организации">
          <h6>Контактная информация</h6>
          <p className="org-subtitle">
            На сайте размещена полная информация об организации: адрес, номер телефона, реквизиты юридического лица.
          </p>
          <ul className="requisites-list">
            {contactLegalData.map((item, i) => (
              <li key={i}>
                <span>{item.name}:</span>
                <strong>{item.value}</strong>
              </li>
            ))}
          </ul>
        </section>
      </div>
    </main>
  );
};

export default Payment;
